export const ENV = {
  API_URL: process.env.REACT_APP_API_URL,
  SERVER_URL: process.env.REACT_APP_SERVER_URL,
  SITE_URL: process.env.REACT_APP_SITE_URL,
  GOOGLE_ANALYTICS_ID:
    process.env.REACT_APP_GOOGLE_ANALYTICS_ID ||
    process.env.REACT_APP_GA_MEASUREMENT_ID,
  GA_MEASUREMENT_ID: process.env.REACT_APP_GA_MEASUREMENT_ID,
  SEARCH_CONSOLE_VERIFICATION:
    process.env.REACT_APP_SEARCH_CONSOLE_VERIFICATION,
  BLOG_URL: process.env.REACT_APP_BLOG_URL,
  FIREBASE: {
    API_KEY: process.env.REACT_APP_FIREBASE_API_KEY,
    AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    STORAGE_BUCKET: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    MESSAGING_SENDER_ID: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    APP_ID: process.env.REACT_APP_FIREBASE_APP_ID,
    MEASUREMENT_ID: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  },
  EMAILJS: {
    SERVICE_ID: process.env.REACT_APP_EMAILJS_SERVICE_ID,
    TEMPLATE_ID: process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
    SENDER_TEMPLATE_ID: process.env.REACT_APP_EMAILJS_SENDER_TEMPLATE_ID,
    PUBLIC_KEY: process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
  },
};

export default ENV;
